import { basicEnum } from "./base";

export const CPEStatusEnum = basicEnum([
    {
        label: "UNINITIALIZED",
        value: "UNINITIALIZED",
    },
    {
        label: "PROVISIONED",
        value: "PROVISIONED",
    },
]);

export namespace CPEStatusEnum {
    export type Labels = (typeof CPEStatusEnum)["labels"][number];
    export type Values = (typeof CPEStatusEnum)["values"][number];
}
